import React from 'react'
import OutOfStockHeader from './OutOfStockHeader'
import OutOfStockInner from './OutOfStockInner'
import OutOfStockFooter from './OutOfStockFooter'
import { getWarehouses, getProductsInventory } from '../../../../ReportsFunctions'

export const outOfStockContext = React.createContext()

function useOutOfStockController(props) {
  return ({
    filter: props.filter,
    getWarehouses,
    getProductsInventory
  })
}

function OutOfStockController(props) {
  const outOfStockController = useOutOfStockController(props)
  return (
    <React.Fragment>
      <outOfStockContext.Provider value={outOfStockController}>
        <OutOfStockHeader />
        <OutOfStockInner />
        <OutOfStockFooter />
      </outOfStockContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(OutOfStockController)